module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_9005.a7c5421d.png";